import { ComponentProps } from 'react';
import { styled, css } from 'styled-components';
import { resetButtonStyles } from '../../styles/helpers.ts';
import { DownArrow } from '../icons';

export type CollapseButtonProps = { collapsed: boolean } & Omit<
  ComponentProps<typeof Button>,
  '$collapsed'
>;

const CollapseButton = ({ collapsed, ...props }: CollapseButtonProps) => (
  <Button $collapsed={collapsed} {...props}>
    <CollapseButtonIcon />
  </Button>
);

const CollapseButtonIcon = styled(DownArrow)`
  width: 40px;
  height: 16px;
`;

const Button = styled.button<{
  $collapsed: boolean;
}>`
  ${resetButtonStyles};
  align-self: center;
  padding: 8px 8px 13px;
  margin-top: 10px;
  color: ${({ theme }) => theme.getColor('accentSecondary')};
  ${({ $collapsed }) =>
    !$collapsed &&
    css`
      ${CollapseButtonIcon} {
        transform: rotate(180deg);
      }
    `}
`;

export { CollapseButton };
